import { Button, ButtonProps } from '@chakra-ui/react'

import { CustomFormScoreClassification } from 'components/tools/CustomForm/types'

type Props = ButtonProps & {
  buttonLabel?: string
  classification: CustomFormScoreClassification
  condition: string
}

export default function ScoreIntervalConditionButton({ buttonLabel, classification, condition, ...props }: Props) {
  return (
    <Button
      {...props}
      width="100%"
      borderWidth="1px"
      borderColor={classification.condition === condition ? 'primary' : 'borderColor'}
      variant="solid"
      colorScheme={classification.condition === condition ? 'primary' : 'gray'}
      size="xs"
    >
      {buttonLabel}
    </Button>
  )
}
